import { HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Container, Skeleton } from 'native-base';
import React from 'react';

import { calculatePercentageWidth, widthCols } from '../../../constants';

export const TableHeadLoading: React.FC = () => {
  return (
    <HStack
      px={Spacing['inset.xs']}
      bg={'brand.tertiary.lightest'}
      h={'44px'}
      alignItems={'center'}
      borderTopRadius={BoxRadius.sm}>
      <VStack width={`${calculatePercentageWidth(widthCols.name)}%`}>
        <Skeleton
          w={'25%'}
          h={Typography['fontsize.md']}
          borderRadius={BoxRadius.sm}
          endColor={Color['brand.primary.lightest']}
        />
      </VStack>
      <VStack width={`${calculatePercentageWidth(widthCols.cpfCnpjFormatted)}%`}>
        <Skeleton
          w={'40%'}
          h={Typography['fontsize.md']}
          borderRadius={BoxRadius.sm}
          endColor={Color['brand.primary.lightest']}
        />
      </VStack>
      <VStack width={`${calculatePercentageWidth(widthCols.accountNumber)}%`}>
        <Skeleton
          w={'35%'}
          h={Typography['fontsize.md']}
          borderRadius={BoxRadius.sm}
          endColor={Color['brand.primary.lightest']}
        />
      </VStack>
      <VStack width={`${calculatePercentageWidth(widthCols.suitabilityProfileName)}%`}>
        <Skeleton
          w={'50%'}
          h={Typography['fontsize.md']}
          borderRadius={'full'}
          endColor={Color['brand.primary.lightest']}
        />
      </VStack>
      <VStack width={`${calculatePercentageWidth(widthCols.registrationStatusName)}%`}>
        <Skeleton
          w={'80%'}
          h={Typography['fontsize.md']}
          borderRadius={'full'}
          endColor={Color['brand.primary.lightest']}
        />
      </VStack>
      <VStack width={`${calculatePercentageWidth(widthCols.availableBalance)}%`}>
        <Skeleton
          w={'75%'}
          h={Typography['fontsize.md']}
          borderRadius={'full'}
          endColor={Color['brand.primary.lightest']}
        />
      </VStack>
      <Container />
    </HStack>
  );
};
